import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import css from './Button.module.css';

export const Button = ({ children, to, href, onClick = () => {}, className, style, primary, invert, small, gray }) => {
	const classes = classnames(css.root, {
		[className]: className,
		[css.small]: small,
		[css.primary]: primary,
		[css.gray]: gray,
		[css.invert]: invert,
	});
	return to ? (
		<Link style={style} className={classes} to={to}>
			{children}
		</Link>
	) : (
		<a style={style} onClick={onClick} href={href} className={classes}>
			{children}
		</a>
	);
};

export default Button;
